import { Box, Card, Stack, Typography, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { apiOperation, headers } from "../../services/api";
import { Error } from "../Error";
import { Loading } from "../Loading";
import { Produto } from "../../models/notouch/produto";
import { Paginacao, Resultado } from "../../models/base/basic";

interface ChooseProductProps {
  selectedProduct: Produto | undefined;
  handleSelectProduct: (productId: Produto) => void;
}

export const ChooseProduct: React.FC<ChooseProductProps> = ({
  selectedProduct,
  handleSelectProduct,
}) => {
  const [productList, setProductList] = useState<Produto[]>([]);
  const [showLoading, setLoading] = useState<boolean>(true);
  const [errorApi, setErrorApi] = useState({
    message: "",
    title: "",
    state: false,
  });

  const getProdutos = async () => {
    try {
      setLoading(true);

      const config = {
        headers: headers()
      };

      const { data } = await apiOperation.get<Resultado<Paginacao<Produto>>>("notouch/produto/listar", config);
      
      if (!data.erro) {
        setProductList([...data.valor.dados]);
        setLoading(false);
      } else {
        setErrorApi({
          title: "Não foi possivel se conectar a API no momento.",
          state: true,
          message: data.erros?.join("<hr />"),
        });
        setLoading(false);
      }
      } catch (error: any) {
        setErrorApi({
          title: `API Não disponivel`,
          message: `Caso o problema continue informe o seguinte erro: ${error?.response?.status}-${error?.response?.statusText}`,
          state: true,
        });
        setLoading(false);
      }
  };

  useEffect(() => {
    getProdutos();
  }, []);

  return (
    <>
      <Stack direction="row" spacing={3} sx={{ justifyContent: "center", width: '100%' }}>
        {productList.map((produto) => (
          <Card
            key={produto.id}
            sx={{
              margin: "0px",
              boxShadow: 2,
              p: 0,
              backgroundColor: selectedProduct?.id === produto.id ? "var(--info-surface)" : "var(--surface-raised)",
              borderWidth: selectedProduct?.id === produto.id ? '2px' : '0',
              borderStyle: 'solid',
              borderColor: 'var(--info)',
              cursor: "pointer",
              borderRadius: 4,
              maxWidth: 500,
              minHeight: 400,
              transition: 'transform 0.3s ease, box-shadow 0.3s ease',
              '&:hover': {
                backgroundColor: selectedProduct?.id === produto.id ? "var(--info-surface)" : "var(--surface-sunken)",
                transform: 'scale(1.03)',
                boxShadow: 6
              },
              display: 'flex',
              flexDirection: 'column'
            }}
            onClick={() => handleSelectProduct(produto)}
          >
            <Box sx={{ 
              flex: 1,
              display: "flex", 
              flexDirection: "column", 
              alignItems: "center", 
              justifyContent: "center",
              p: 3,
              background: "var(--info)",
              color: "var(--text-on-inverse)",
              borderTopLeftRadius: 12,
              borderTopRightRadius: 12,
            }}>
              <Typography variant="h4" component="div" sx={{ fontWeight: 'bold', mb: 2 }}>
                {produto.nome}
              </Typography>
              <Typography component="div" variant="h5">
                {new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL'
                }).format(produto.preco)}{produto.assinatura ? "/mês" : ""}
              </Typography>
            </Box>
            <Box sx={{ 
              flex: 1,
              display: "flex", 
              flexDirection: "column", 
              alignItems: "center", 
              justifyContent: "space-between",
              p: 3,
              borderBottomLeftRadius: 12,
              borderBottomRightRadius: 12,
            }}>
                <Typography component="div" variant="h6" sx={{ fontWeight: 'bold' }}>
                  {produto.valor} Créditos
                </Typography>
              <Box sx={{ width: '100%', textAlign: 'center' }}>
                <Typography component="div" variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
                  {produto.assinatura ? "Recorrência Anual" : "Sem Recorrência"}
                </Typography>
              </Box>
              
              <Button 
                variant="contained" 
                sx={{ 
                  backgroundColor: 'var(--action-primary-surface)',
                  '&:hover': {
                    backgroundColor: 'var(--action-primary-surface)'
                  }
                }}
                onClick={() => handleSelectProduct(produto)}
                fullWidth
              >
                Selecionar Produto
              </Button>
            </Box>
          </Card>
        ))}
      </Stack>
      <Loading
        mode="blurry"
        hidden={!showLoading}
        messages="Consultando..."
      ></Loading>
      <Error
        hasOpen={errorApi.state}
        handleClose={() => setErrorApi({ ...errorApi, state: false })}
        errorMsg={errorApi.message}
        title={errorApi.title}
      />
    </>
  );
};